const LEGACY_INVESTOR_EXACT_DESTINATIONS: Readonly<Record<string, string>> = {
  "/allocations": "/alpha/discover",
  "/dashboard": "/alpha/dashboard",
  "/positions": "/alpha/positions",
  "/positions/activity": "/alpha/activity",
  "/positions/discover": "/alpha/discover",
  "/positions/notifications": "/alpha/profile",
  "/positions/onboarding": "/alpha/setupv2",
  "/positions/profile": "/alpha/profile",
  "/positions/settings": "/alpha/profile",
  "/settings": "/alpha/profile",
  "/strategy": "/alpha/dashboard",
  "/strategy/analyze": "/alpha/analyze",
};

function trimTrailingSlashes(pathname: string): string {
  return pathname.replace(/\/+$/, "") || "/";
}

export function getAlphaDestinationForLegacyInvestorPath(
  pathname: string
): string | null {
  const normalizedPathname = trimTrailingSlashes(pathname);
  const lowerPathname = normalizedPathname.toLowerCase();
  const exactDestination = LEGACY_INVESTOR_EXACT_DESTINATIONS[lowerPathname];

  if (exactDestination) return exactDestination;

  const discoverPrefix = "/positions/discover";
  if (lowerPathname.startsWith(`${discoverPrefix}/`)) {
    return `/alpha/discover${normalizedPathname.slice(discoverPrefix.length)}`;
  }

  if (lowerPathname.startsWith("/dashboard/")) {
    return "/alpha/dashboard";
  }

  return null;
}

export function isLegacyInvestorPath(pathname: string): boolean {
  return getAlphaDestinationForLegacyInvestorPath(pathname) !== null;
}

export function getPostAuthDestination(
  requestedLocation: string | {
    pathname: string;
    search?: string;
    hash?: string;
  } | null | undefined,
  defaultLandingPage: string
): string {
  const requestedPathname = typeof requestedLocation === "string"
    ? requestedLocation
    : requestedLocation?.pathname;
  if (!requestedPathname || isLegacyInvestorPath(requestedPathname)) {
    return defaultLandingPage;
  }

  if (typeof requestedLocation === "string") return requestedPathname;
  return `${requestedPathname}${requestedLocation?.search ?? ""}${requestedLocation?.hash ?? ""}`;
}
